import React, { useEffect, useState } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import MaterialTable from "material-table";
import menuthree from "../../../assets/images/menuthree.png";
import { FaPen, FaKey, FaTrash } from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import { Button, CircularProgress, Paper } from "@material-ui/core";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { DataGrid } from "@mui/x-data-grid";
import CommonMenu from "../../../Common/CommonMenu";
import EditIcon from "@mui/icons-material/Edit";
import CustomSearch from "../../../Common/CustomSearch";
import { useSelector } from "react-redux";

const Sports = () => {
  const [sportsData, setSportsData] = useState([]);
  const history = useHistory();
  const schoolId = getFromLocalStorage("schoolId");
  const [loading, setLoading] = useState(false);

  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 0,
    pageSize: 10,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedRecord, setSearchedRecord] = useState(false);
  const [recordNotFound, setRecordNotFound] = useState(false);
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  useEffect(() => {
    setLoading(true);
    getAllSports();
  }, []);

  const getAllSports = (page, size) => {
    userService.getSports(schoolId).then((res) => {
      setPageState((old) => ({
        ...old,
        isLoading: false,
        data: [res.data.data],
        total: 1,
      }));
      setLoading(false);
      if (recordNotFound) {
        setRecordNotFound(false);
      }

      setLoading(false);
    });
  };

  const searchSports = (query, page, size) => {
    setPageState((old) => ({
      ...old,
      isLoading: true,
    }));
    setSearchQuery(query);
    if (!searchedRecord) {
      setSearchedRecord(true);
    }
    userService
      .searchSport(query, schoolId, page, size)
      .then((res) => {
        const response = res.data.data;
        const data = [];
        response.map((item) => {
          data.push({
            id: item.sport.id,
            sportId: item.sport.id,
            sport: item.sport.sportName,
            playLevel: item.sport.playLevel,
            teamAdmins: item.sport.teamAdmins,
            coaches: item.sport.coaches,
            athletes: item.sport.athletes,
            uploadedLogo: item.sport.uploadedLogo,
          });
        });
        setPageState((old) => ({
          ...old,
          isLoading: false,
          data: data,
          total: 1,
          page: 0,
        }));
        data.length == 0 ? setRecordNotFound(true) : setRecordNotFound(false);
      })
      .catch((err) => {
        setRecordNotFound(true);
        setPageState((old) => ({
          ...old,
          isLoading: false,
          data: [],
          total: 0,
          page: page,
        }));
      });
  };

  const tableColumns = [
    {
      field: "sport",
      headerName: "Sport",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 200,
      align: "center",
      renderCell: (params) => (
        <div className="d-flex-center height-70 w-100">
          <p className="link-blue text-width-auto mg-left-10">
            {params.row.sport}
          </p>
        </div>
      ),
    },
    {
      field: "playLevel",
      headerName: "Play Level",
      headerAlign: "center",
      headerClassName: "table-header bold",
      align: "center",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "teamAdmins",
      headerName: "Team Admins",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 200,
      align: "center",
      renderCell: (params) => (
        <p className="skBlue">
          {params.row.teamAdminCount ? params.row.teamAdminCount : 0}
        </p>
      ),
    },
    {
      field: "coaches",
      headerName: "Coaches",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 200,
      align: "center",
      renderCell: (params) => (
        <p className="skBlue">
          {params.row.coachesCount ? params.row.coachesCount : 0}
        </p>
      ),
    },
    {
      field: "athletes",
      headerName: "Athletes",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 200,
      align: "center",
      renderCell: (params) => (
        <p className="skBlue">
          {params.row.athletesCount ? params.row.athletesCount : 0}
        </p>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      headerClassName: "table-header bold",
      width: 200,
      cellClassName: "custom-cell",
      align: "center",
      renderCell: (params) => (
        <CommonMenu
          menuContent={menuItemContent(params.row)}
          rowData={params.row}
        />
      ),
    },
  ];

  const menuItemContent = () => {
    const arr = [
      {
        id: "1",
        name: "Edit Details",
        icon: <EditIcon className="manage-section-iconss" />,
        ApiCall: redirectToEditPage,
      },
    ];
    return arr;
  };

  const redirectToEditPage = (row) => {
    history.push(`/editsports/${row?.storage?.sport?.id}`);
  };

  return (
    <div>
      <SchoolAdminDashboard />
      <div>
        <div
          className={
            isDrawerOpen ? "content-layout p-0" : "toggle-content-layout p-0"
          }
        >
          {loading ? (
            <div className="content-layout-loading-animation">
              <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                <CircularProgress
                  className="rounded-circle"
                  color="success"
                  sx={{ fontSize: 10, color: "#002244" }}
                  disableShrink
                />
              </div>
            </div>
          ) : (
            <>
              <div className="mng-header stickyy">
                <h4 className="fs-24 bold mob-hd">Sports</h4>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr">
                {!loading && (pageState.data.length > 0 || recordNotFound) && (
                  <Paper className="pad-top-20 mg-bottom-20">
                    <CustomSearch
                      searchQuery={searchQuery}
                      searchedRecord={searchedRecord}
                      setSearchedRecord={setSearchedRecord}
                      setSearchQuery={setSearchQuery}
                      getDataByPage={getAllSports}
                      searchData={searchSports}
                      pageState={pageState}
                      setRecordNotFound={setRecordNotFound}
                    />
                    <DataGrid
                      rows={pageState.data}
                      columns={tableColumns}
                      loading={pageState.isLoading}
                      page={pageState.page}
                      pageSize={pageState.pageSize}
                      paginationMode="server"
                      rowsPerPageOptions={[10]}
                      autoHeight
                      disableColumnMenu
                      getRowHeight={() => "auto"}
                      disableSelectionOnClick
                      sx={{
                        color: "black",
                        fontFamily: "Rajdhani-SemiBold",
                        fontSize: "18px",
                        backgroundColor: "white",
                        borderBottomLeftRadius: "12px",
                        borderBottomRightRadius: "12px",
                      }}
                      onRowClick={(params) => redirectToEditPage(params.row)}
                    />
                  </Paper>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sports;
